import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssessmentAgencyService } from 'projects/services/src/app/API/assessment-agency.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
declare var toastr: any;
@Component({
	selector: 'app-aa-profile',
	templateUrl: './aa-profile.component.html',
	styleUrls: ['./aa-profile.component.css']
})
export class AaProfileComponent implements OnInit {
	assessorID: any;
	assessorDetails: any;
	indusExpYrs = 0;
	indusExpMnths = 0;
	trainExpYrs = 0;
	trainExpMnths = 0;
	generalDetailsFormGroup: FormGroup;
	singlePointInfoFormGroup: FormGroup;
	addressDetailFormGroup: FormGroup;
	otherInformationFormGroup: FormGroup;
	assessmentData: any = [];
	financialTurnOver: any = [];
	bankdetails: any = [];
	languageList: any = [];
	associateSScData: any = [];
	sscData: any = [];
	associateAa: any = [];
	assessorName: any;
	email: any;
	website: any;
	mobile: any;
	assessmetModeList: any;
	fileData: any;
	loginRole: void;
	isbankdetails: boolean = true;
	constructor(
		private assessmentagencyservice: AssessmentAgencyService,
		private formBuilder: FormBuilder,
		private currentUserService: CurrentUserService,
		private router: Router,
		private route: ActivatedRoute,
		private fileService: FileService,
		public location: Location,
	) {
		console.log(this.route.snapshot.params.id);

		this.currentUserService.getCurrentUser().subscribe(data => {
			if (data) {
				this.assessmentData = data;
				this.fileData = data;
				this.loginRole = data.role;
				console.log(data);
				this.assessorName = data.name;
				this.email = data.spoc && data.spoc.email ? data.spoc.email : '';
				this.website = data.website;
				this.mobile = data.spoc && data.spoc.mobileNumber ? data.spoc.mobileNumber : '';
				this.assessorID = data.userName;
			} else {
				this.location.back();
			}
			if (data && data.financialYearwiseTurnOverDetail) {
				this.financialTurnOver = data.financialYearwiseTurnOverDetail;
			} else {
				this.financialTurnOver = [];
			}

			if (data.bankpandetails) {
				this.bankdetails = data.bankpandetails;
				console.log(this.bankdetails.ifscCode);
				this.isbankdetails = true;
			} else {
				this.isbankdetails = false;
				this.bankdetails = [];
			}
			console.log(this.financialTurnOver);

			console.log(this.assessmentData);
		})
		this.getAssociateSSc();
		this.getAssociateAA();
	}
	createForm() {
		this.generalDetailsFormGroup = this.formBuilder.group({
			nameOfAssAgency: {
				value: this.assessmentData && this.assessmentData.name || 'N/A',
				disabled: true
			},
			role: {
				value: this.assessmentData && this.assessmentData.role || 'N/A',
				disable: true
			},
			assAgencyId: {
				value: this.assessmentData && this.assessmentData.userName || 'N/A',
				disabled: true
			},
			typeOfAA: {
				value: this.assessmentData && this.assessmentData.type || 'N/A',
				disabled: true
			},
			overallExp: {
				value: this.assessmentData && this.assessmentData.overAllExperience || 'N/A',
				disabled: true
			},
			aaAfilliation: {
				value: this.assessmentData && this.assessmentData.assessmentAgencyAffiliation || 'N/A',
				disabled: true
			},
			affWithSsc: {
				value: this.assessmentData && this.assessmentData.affiliatedWithOtheSSC || 'N/A',
				disabled: true
			},
			modeOfAssessment: {
				value: this.assessmentData && this.assessmentData.modeOfAssessment || 'N/A',
				disabled: true
			},
			otherModeOfAssessment: {
				value: this.assessmentData && this.assessmentData.otherModeOfAssessment || 'N/A',
				disabled: true,
			},
			languageKnown: {
				value: this.assessmentData && this.assessmentData.languagesForAssessment || 'N/A',
				disabled: true
			},
			isoCertification: {
				value: this.assessmentData && this.assessmentData.isoCertificationDetail &&
					this.assessmentData.isoCertificationDetail.isoCertified || 'N/A',
				disabled: true
			},

			// isoDoc: {value: this.assessmentData.isoCertificationDetail['supportingDocument'], disabled: true},
		});
		this.singlePointInfoFormGroup = this.formBuilder.group({
			nameOfSpoc: { value: this.assessmentData && this.assessmentData.spoc && this.assessmentData.spoc.firstName || 'N/A', disabled: true },
			email: { value: this.assessmentData && this.assessmentData.spoc && this.assessmentData.spoc.email || 'N/A', disabled: true },
			phoneNumber: { value: this.assessmentData && this.assessmentData.spoc && this.assessmentData.spoc.mobileNumber || 'N/A', disabled: true }
		})
		this.addressDetailFormGroup = this.formBuilder.group({
			address: {
				value: this.assessmentData && this.assessmentData.address &&
					this.assessmentData.address.address1 ? this.assessmentData.address.address1 : '',
				disabled: true
			},
			incorpYear: {
				value: this.assessmentData && this.assessmentData.yearOfEstablishmentDetails && this.assessmentData.yearOfEstablishmentDetails.year,
				disabled: true
			},
			landMark: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.landmark || 'N/A',
				disabled: true
			},
			pinCode: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.pinCode || 'N/A',
				disabled: true
			},
			state: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.state && this.assessmentData.address.state.name || 'N/A',
				disabled: true
			},
			district: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.district && this.assessmentData.address.district.name || 'N/A',
				disabled: true
			},
			tehsil: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.mandal && this.assessmentData.address.mandal.name || 'N/A',
				disabled: true
			},
			city: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.city && this.assessmentData.address.city.name || 'N/A',
				disabled: true
			},
			parliamentConsti: {
				value: this.assessmentData && this.assessmentData.address && this.assessmentData.address.parliamentConstituency && this.assessmentData.address.parliamentConstituency.name || 'N/A',
				disabled: true
			},
			// addressProof:  {value: this.assessmentData &&  this.assessmentData.address &&  this.assessmentData.address.proof.addressProof || 'N/A',  disabled: true},
		})
		this.otherInformationFormGroup = this.formBuilder.group({
			candidateAssessedDate: {
				value: this.assessmentData && this.assessmentData.otherInformation && this.assessmentData.otherInformation.candidatesAssessedTillDate || 'N/A',
				disabled: true
			},
			numberOfAdminStaff: {
				value: this.assessmentData && this.assessmentData.otherInformation && this.assessmentData.otherInformation.numberOfAdminStaff || 'N/A',
				disabled: true
			},
			workingUnderProject: {
				value: this.assessmentData && this.assessmentData.otherInformation && this.assessmentData.otherInformation.workingUnderOtherProject || 'N/A',
				disabled: true
			},
			keyAchievements: {
				value: this.assessmentData && this.assessmentData.otherInformation && this.assessmentData.otherInformation.keyAchievements || 'N/A',
				disabled: true
			},
		})
	}

	getAssessmentAgencyData(id) {
		this.assessmentagencyservice.getAssesmentAgencyByUserName(id).subscribe(res => {
			console.log(res)
			this.assessmentData = res
			this.createForm();
			this.generalDetailsFormGroup.get('role').value.value = this.loginRole;
			// this.generalDetailsFormGroup.patchValue(res);
			// this.assessmentAgencyDataForm.get('address').get('yearOfEstablishmentDetails').get('year').
			// 	setValue(res.yearOfEstablishmentDetails.year ? res.yearOfEstablishmentDetails.year : '0000');
			// if (res.isoCertificationDetail.isoCertified) {
			// 	this.assessmentAgencyDataForm.get('isoCertificationDetail').get('isoCertified').setValue('YES');
			// } else {
			// 	this.assessmentAgencyDataForm.get('isoCertificationDetail').get('isoCertified').setValue('NO');
			// }
			if (res.financialYearwiseTurnOverDetail) {
				this.financialTurnOver = res.financialYearwiseTurnOverDetail
			} else {
				this.financialTurnOver = []
			}
		})
	}

	ngOnInit() {
		// this.currentUserService.getCurrentUser().subscribe(data => {
		// 	if (data) {
		// 		this.assessmentData = data;
		// 	}
		// })
		// this.assessorID = this.router.snapshot.params.assessorID;
		this.createForm();
		this.getAllLanguages();
		if (this.assessmentData && this.assessmentData.role && this.assessmentData.role === 'Assessment PMU') {
			this.getAssessmentAgencyData(this.route.snapshot.params.id);
		}
	}
	getAllLanguages() {
		this.assessmentagencyservice.getAssessmentAgencyRegDd().subscribe(res => {
			if (res.languagesKnown) {
				this.languageList = res.languagesKnown;
				console.log(this.languageList);
			}
			if (res.modeOfAssessment) {
				this.assessmetModeList = res.modeOfAssessment
			}
		})
	}

	prviewFile(file) {
		console.log(file);
		this.fileService.downloadAttachedFile(file);

	}
	opeFile(certificate) {
		if (certificate) {
			this.fileService.downloadAttachedFile(certificate);
		} else {
			toastr.error('Finance Document Not Found');
		}

	}

	previewIsoDoc() {
		if (this.fileData.isoCertificationDetail) {
			this.fileService.downloadAttachedFile(this.fileData.isoCertificationDetail.supportingDocument);
		} else {
			toastr.error('No ISO Document Found');
		}
	}

	viewAddressProof() {
		console.log(this.fileData.address.proof);

		if (this.fileData.address.proof) {
			this.fileService.downloadAttachedFile(this.fileData.address.proof.supportingDocument);
		} else {
			toastr.error('No Address Document Found');
		}
	}


	editProfile() {
		this.router.navigate(['./edit-profile'], {
			relativeTo: this.route.parent
		});
	}
	getAssociateSSc() {
		this.assessmentagencyservice.getAssociateSSc(this.assessmentData.userName).subscribe(res => {
			if (res.data) {
				for (let index = 0; index < res.data.length; index++) {
					console.log(res.data[index].linkedSectors.subSectors);
					this.associateSScData.push(res.data[index])
					// Helpers.copyArray(this.associateSScData, res.data[index].linkedSectors)
				}
				console.log(this.associateSScData);
				for (let ind = 0; ind < this.associateSScData.length; ind++) {
					this.sscData.push(this.associateSScData[ind]);
				}
				console.log(this.sscData);
				// Helpers.copyArray(this.associateSScData, res.data)
			} else {
				this.assessmentData = [];
				this.sscData = [];
			}
		})
	}
	getState(data) {
		if (data && data.linkedSectors && data.linkedSectors.subSectors) {
			for (let index = 0; index < data.linkedSectors.subSectors.length; index++) {
				if (data.linkedSectors.subSectors[index] && data.linkedSectors.subSectors[index].jobRoles) {
					for (let ind = 0; ind < data.linkedSectors.subSectors[index].jobRoles.length; ind++) {
						return data.linkedSectors.subSectors[index].jobRoles[ind].state.name;
					}
				} else {
					return 'N/A'
				}
			}
		} else {
			return 'N/A'
		}

	}
	getDistrict(data) {
		if (data && data.linkedSectors && data.linkedSectors.subSectors) {
			for (let index = 0; index < data.linkedSectors.subSectors.length; index++) {
				if (data.linkedSectors.subSectors[index] && data.linkedSectors.subSectors[index].jobRoles) {
					for (let ind = 0; ind < data.linkedSectors.subSectors[index].jobRoles.length; ind++) {
						if (data.linkedSectors.subSectors[index].jobRoles[ind] && data.linkedSectors.subSectors[index].jobRoles[ind].state &&
							data.linkedSectors.subSectors[index].jobRoles[ind].state.districts) {
							for (let indOne = 0; ind < data.linkedSectors.subSectors[index].jobRoles[ind].state.districts.length; indOne++) {
								return data.linkedSectors.subSectors[index].jobRoles[ind].state.districts[indOne].name;
							}
						} else {
							return 'N/A'
						}
					}
				} else {
					return 'N/A'
				}
			}
		} else {
			return 'N/A'
		}
	}

	getJobRoleName(data) {
		if (data && data.linkedSectors && data.linkedSectors.subSectors) {
			for (let index = 0; index < data.linkedSectors.subSectors.length; index++) {
				if (data.linkedSectors.subSectors[index] && data.linkedSectors.subSectors[index].jobRoles) {
					for (let ind = 0; ind < data.linkedSectors.subSectors[index].jobRoles.length; ind++) {
						return data.linkedSectors.subSectors[index].jobRoles[ind].jobrole
					}
				} else {
					return 'N/A'
				}
			}
		} else {
			return 'N/A'
		}
	}

	getAssociateAA() {
		console.log(this.assessmentData);
		let id;
		if (this.assessmentData.role === 'Assessment PMU') {
			id = this.route.snapshot.params.id
		} else {
			id = this.assessmentData.userName
		}
		this.assessmentagencyservice.getAssociateAA(id).subscribe(res => {
			console.log(res);

			if (res.data) {
				for (let index = 0; index < res.data.length; index++) {
					this.associateAa.push(res.data[index])
				}
			}
			console.log(this.associateAa);

		})
	}
}
